import { Component } from "@angular/core";
import { NewUiProtectedshortLinkComponent } from "./new-ui-protectedshortLink.component";

@Component({
  selector: "app-protected-short-link",
  template: "<p>File downloaded...</p>",
})
export class ProtectedShortLinkComponent extends NewUiProtectedshortLinkComponent {}
